import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpItemsService} from '../../services/http/http-items.service';
import {DomSanitizer} from '@angular/platform-browser';
import {Lightbox} from 'ngx-lightbox';
import {ChartCore} from '@easycomp/easy-charts/lib/definitions/enums';
import {CzechNumberFormatPipe} from '../pipes/czech-number-format.pipe';

@Component({
    selector: 'app-project-detail',
    templateUrl: './project-detail.component.html',
    styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {

    project: any;
    data: any;

    budget: any;
    grant: any;
    album: Array<{src: string, caption: string, thumb: string}>;
    fieldSumData: any;

    sumData = {
        data: [],
        colors: [{backgroundColor: ['#5C8FB6', '#bebcc0']}],
        labels: ['Dotace', 'Spoluúčast'],
        groups: ['Dotace', 'Spoluúčast'],
        ready: false
    };

  fieldSumChartOptions = {
    core: ChartCore.JS,
    labelFunction: (sector, data) => {
      if(sector.index) {
        return 'Spoluúčast (' + this.czechNumberPipe.transform(Math.round(this.budget - this.grant)) + ' Kč)';
      } else {

        return 'Dotace (' + this.czechNumberPipe.transform(this.grant) + ' Kč)';
      }
    },
    legendPercentace: true
  };


    constructor(private route: ActivatedRoute,
                private httpItem: HttpItemsService,
                private domSanitate: DomSanitizer,
                private lightbox: Lightbox,
                private czechNumberPipe: CzechNumberFormatPipe) {
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            this.httpItem.getItemById(params.id).subscribe((result) => {
                this.sumData.ready = false;
                this.project = result.body;

                this.project.fields.forEach( (item) => {
                   switch (item.field_id) {
                        case 12:
                         item.type = 'colored';
                         item.value = item.value.split(';');
                         break;
                       case 14: // TODO: magické constanty by měli bát někde centrálně jako je to v php
                           this.budget = parseInt(item.value.replace(/ /gi, ''), 0);
                           break;
                       case 18:
                           item.type = 'colored';
                           item.value = item.value.split(';');
                           break;
                       case 19:
                           this.grant = parseInt(item.value.replace(/ /gi, ''), 0);
                           break;
                       case 20:
                           if (this.grant === 0) {
                             item.value = 0;
                             this.sumData.data = [
                               {label: 'Dotace', value: 0, color: '#386641'},
                               {label: 'Spolúčast', value: 100, color: '#6A994E'}
                             ];
                           } else {
                               item.value = 100 - Math.round(this.grant / (this.budget / 100));
                               // this.sumData.data.push({data: [(100 - item.value), item.value]});
                               this.sumData.data = [
                                 {label: 'Dotace', value: (100 - item.value), color: '#386641'},
                                 {label: 'Spolúčast', value: item.value, color: '#6A994E'}
                               ];
                           }
                           break;
                       case 25:
                           item.type = 'mailTo';
                           item.value = item.value.split(';');
                           break;
                   }
                });
                this.sumData.ready = true;
                // Připrav lightbox
                this.album = [];
                this.project.images.forEach( (image) => {
                  const album = {
                    src: 'https://projektydecin.cz/media/djcatalog2/images/' + image.fullpath,
                    caption: image.caption,
                    thumb: 'https://projektydecin.cz/media/djcatalog2/images/' + image.fullpath
                  };

                  this.album.push(album);
                });
            });
        });
    }

    getSanitizedMapLink(lat, long) {
        return this.domSanitate.bypassSecurityTrustResourceUrl(
            'https://www.google.com/maps?q=' + lat + '%2C+' + long + '&z=14&t=m&output=embed'
        );
    }

    isNaN(value: any) {
        return parseFloat(value);
    }

  openLightBox(i: number) {
    this.lightbox.open(this.album, i);
  }
  close(): void {
    // close lightbox programmatically
    this.lightbox.close();
  }
}
